import { render, staticRenderFns } from "./GameCompletePage.vue?vue&type=template&id=b7296bfa&scoped=true&"
import script from "./GameCompletePage.vue?vue&type=script&lang=ts&"
export * from "./GameCompletePage.vue?vue&type=script&lang=ts&"
import style0 from "./GameCompletePage.vue?vue&type=style&index=0&id=b7296bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7296bfa",
  null
  
)

export default component.exports